import React from 'react';
import { useIntl } from 'react-intl';

import Container from '@/components/Container/Container';
import PageNext from '@/components/Page/PageNext';
import Typography from '@/components/Typography/Typography';
import { NextPage } from '@/pages/_app';

const PrivacyPolicyPage: NextPage = () => {
  const intl = useIntl();
  return (
    <PageNext title={intl.formatMessage({ id: 'app.privacypolicy.pagetitle' })}>
      <Container maxWidth="md" verticalPadding>
        <Typography variant="h2" component="h1" spacing={4}>
          ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          Версия №1 от:
          <br />
          «28» октября 2019 г.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          1. ОБЩИЕ ПОЛОЖЕНИЯ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          1.1. Политика конфиденциальности (далее – Политика) публикуется ООО &laquo;Смарт Манкиз&raquo; ОГРН
          1187746655359, ИНН/КПП 7743264341 / 774301001, место нахождения 125008, город Москва, проезд Черепановых, дом
          36 (далее – Оператор) для информирования об осуществляемой Оператором политике в отношении обработки
          персональных данных пользователей сайта Оператора – субъектов персональных данных (далее – Пользователь).
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          1.2. Политика разработана и опубликована Оператором в соответствии с п. 2 ч. 1 ст. 18.1 Федерального закона от
          27 июля 2006 г. № 152-ФЗ «О персональных данных» (далее – ФЗ «О персональных данных»).
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          1.3. Политика разработана в целях реализации требований законодательства в области обработки и защиты
          персональных данных и направлена на обеспечение защиты прав и свобод человека и гражданина при обработке его
          персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личной и семейной тайны.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          1.4. Политика содержит сведения, подлежащие раскрытию в соответствии с ч. 1 ст. 14 ФЗ «О персональных данных»,
          является общедоступным документом и расположена по адресу: https://geecko.ru.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          1.5. Для поддержания в актуальном состоянии документов, определяющих политику Оператора в отношении обработки
          персональных данных, Оператор вправе в любой момент изменить настоящую Политику, опубликовав соответствующие
          изменения. Настоящая Политика не может быть изменена, кроме как посредством опубликования измененного
          документа на Сайте.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          2. ОСНОВНЫЕ ПОНЯТИЯ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          2.1. Персональные данные – любая информация, относящаяся к прямо или косвенно определенному или определяемому
          физическому лицу (субъекту персональных данных).
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          2.2. Обработка персональных данных – любое действие (операция) или совокупность действий (операций),
          совершаемых с использованием средств автоматизации или без использования таких средств с персональными
          данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение),
          извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование,
          удаление, уничтожение персональных данных.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          2.3. Оператор персональных данных – самостоятельно или совместно с другими лицами организующее и (или)
          осуществляющее обработку персональных данных, а также определяющее цели обработки персональных данных, их
          состав, подлежащий обработке, действия (операции), совершаемые с персональными данными Пользователей.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          2.4. Конфиденциальность персональных данных – обязанность Оператора и иных лиц, получивших доступ к
          персональным данным, не раскрывать третьим лицам и не распространять их без согласия субъекта персональных
          данных, если иное не предусмотрено федеральным законом.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          2.5. Сайт – совокупность программ для электронных вычислительных машин и иной информации, содержащейся в
          информационной системе, доступ к которой обеспечивается посредством информационно-телекоммуникационной сети
          интернет и расположенной по адресу: https://geecko.ru. На Сайте могут находится ссылки на другие
          интернет-ресурсы. Оператор не несет ответственность за конфиденциальность информации, размещенной
          Пользователем на таких ресурсах.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          3. ПРАВА ПОЛЬЗОВАТЕЛЯ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          3.1. Пользователь имеет право:
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          3.1.1. На получение персональных данных, относящихся к Пользователю, и информации, касающейся их обработки;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          3.1.2. На уточнение, блокирование или уничтожение его персональных данных в случае, если они являются
          неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели
          обработки;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          3.1.3. На отзыв данного им согласия на обработку персональных данных;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          3.1.4. На защиту своих прав и законных интересов, в том числе на возмещение убытков и компенсацию морального
          вреда в судебном порядке;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          3.1.5. На обжалование действий или бездействия Оператора в уполномоченный орган по защите прав субъектов
          персональных данных или в судебном порядке.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          4. ОСНОВАНИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          4.1 Оператор обрабатывает персональные данные на законной и справедливой основе для выполнения возложенных
          законодательством функций, полномочий и обязанностей, осуществления прав и законных интересов Оператора и
          Пользователя.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          4.2 Оператор получает персональные данные непосредственно от Пользователя и осуществляет их обработку
          исключительно с согласия Пользователя. Оператор получает персональные данные Пользователя при его в
          взаимодействии с отдельными функциями Сайта.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          5. ОБРАБОТКА ПЕРСОНАЛЬНЫХ ДАННЫХ ПОЛЬЗОВАТЕЛЕЙ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.1. Настоящая Политика устанавливает обязательства Оператора по неразглашению и обеспечению режима защиты
          конфиденциальности персональных данных, которые Пользователь предоставляет при использовании Сайта.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.2. Оператор обрабатывает персональные данные Пользователей в целях соблюдения норм законодательства РФ, а
          также с такой(-ими) целью(-ями) как:
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.2.1. Заключение и исполнение договоров.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.2.2. Информирование о новых товарах, услугах.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.2.3. Подготовка индивидуальных предложений.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.2.4. Публикация на сайте, во внутренних справочниках, адресных книгах организации.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.2.5. Осуществление деятельности в соответствии с учредительными документами.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.3. Оператор обрабатывает персональные данные Пользователей с их согласия, полученного путем проставления
          специальной отметки («галочки») в поле под формой сбора персональных данных, размещенной на Сайте.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4. Категории персональных данных, которые Оператор собирает для достижения целей, указанных в пункте 5.2.
          Политики:
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.1. Фамилия.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.2. Имя.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.3. Отчество.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.4. Контактный телефон.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.5. Адрес электронной почты.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.6. Идентификатор пользователя, хранимый в cookie.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.7. Образование.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.8. Профессия.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.9. Должность.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.4.10. Сведения об оказанных услугах.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.5. Оператор не обрабатывает специальные категории персональных данных Пользователей.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.6. Оператор не обрабатывает биометрические категории персональных данных Пользователей.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.7. Настоящая Политика применима только к информации, обрабатываемой в ходе использования Сайта. Оператор не
          контролирует и не несет ответственность за обработку информации сайтами и сервисами третьих лиц, на которые
          Пользователи могут перейти по ссылкам, доступным внутри Сайта.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          5.8. Оператор не проверяет достоверность персональных данных, предоставляемых Пользователем, и не имеет
          возможности оценивать его дееспособность. Однако Оператор исходит из того, что Пользователь предоставляет
          достоверные и достаточные персональные данные и поддерживают их в актуальном состоянии.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          6. ОБРАБОТКА ПЕРСОНАЛЬНЫХ ДАННЫХ ПОЛЬЗОВАТЕЛЕЙ С ИПОЛЬЗОВАНИЕМ ФАЙЛОВ COOKIE
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          6.1. Файлы cookie, передаваемые техническим устройствам Пользователей, могут использоваться для предоставления
          Пользователям персонализированных функций Сайта, для персональной рекламы, которая показывается Пользователям,
          в статистических и исследовательских целях, а также для улучшения Сайта.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          6.2. Пользователи осознают, что оборудование и программное обеспечение, используемые ими для посещения сайтов
          в сети интернет, могут обладать функцией запрещения операций с файлами cookie (для любых сайтов или для
          определенных сайтов), а также удаления ранее полученных файлов cookie.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          6.3. Оператор вправе установить, что предоставление определенных функций Сайта возможно лишь при условии, что
          прием и получение файлов cookie разрешены Пользователями.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          6.4. Структура файла cookie, его содержание и технические параметры определяются Оператором и могут изменяться
          без предварительного уведомления Пользователей.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          6.5. Счетчики, размещенные на сайте или приложении Сайта, могут использоваться для анализа файлов cookie
          Пользователей, для сбора и обработки статистической информации об использовании Сайта, а также для обеспечения
          работоспособности Сайта в целом или его отдельных функций в частности. Технические параметры работы счетчиков
          определяются Оператором и могут изменяться без предварительного уведомления Пользователей.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          7. УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ ПОЛЬЗОВАТЕЛЕЙ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.1. Обработка персональных данных Пользователей ограничена сроком достижения целей обработки.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.2. Оператор обрабатывает персональные данные Пользователей автоматизированным способом с использованием
          средств вычислительной техники.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.3. Действия по обработке персональных данных включают сбор, запись, систематизацию, накопление, хранение,
          уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление,
          доступ), обезличивание, блокирование, удаление и уничтожение.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.4. В отношении персональных данных Пользователей сохраняется их конфиденциальность, кроме случаев
          добровольного предоставления Пользователями информации о себе для общего доступа неограниченному кругу лиц.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.5. Оператор вправе передать персональные данные Пользователя третьим лицам в следующих случаях:
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.5.1. Пользователи выразили согласие на такие действия;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.5.2. Передача необходима для использования Пользователями определенных функций Сайта либо для исполнения
          определенного соглашения или договора;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.5.3. Передача предусмотрена российским или иным применимым законодательством в рамках установленной
          законодательством процедуры;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.5.4. Такая передача происходит в рамках продажи или иной передачи бизнеса (полностью или в части), при этом
          к приобретателю переходят все обязательства по соблюдению условий настоящей Политики применительно к
          полученным им персональным данным;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.5.5. В результате обработки персональных данных Пользователей путем их обезличивания получены обезличенные
          статистические данные, которые передаются третьему лицу для проведения исследований, выполнения работ или
          оказания услуг по поручению Оператора;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.5.6. Персональные данные Пользователей могут быть переданы уполномоченным органам государственной власти
          Российской Федерации по основаниям и в порядке, установленным действующим законодательством Российской
          Федерации.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.6. При обработке персональных данных Пользователей Оператор руководствуется:
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.6.1. Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных»;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.6.2. Постановлением Правительства Российской Федерации от 01.11.2012 г. № 1119 «Об утверждении требований к
          защите персональных данных при их обработке в информационных системах персональных данных»;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.6.3. Приказом ФСТЭК России от 18 февраля 2013 г. № 21 «Об утверждении Состава и содержания организационных и
          технических мер по обеспечению безопасности персональных данных при их обработке в информационных системах
          персональных данных»;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.6.4 Приказом ФСБ России от 10.07.2014 № 378 «Об утверждении Состава и содержания организационных и
          технических мер по обеспечению безопасности персональных данных при их обработке в информационных системах
          персональных данных с использованием средств криптографической защиты информации, необходимых для выполнения
          установленных Правительством Российской Федерации требований к защите персональных данных для каждого из
          уровней защищенности».
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.6.5. Оператор принимает необходимые организационные и технические меры для защиты персональных данных
          Пользователя от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования,
          распространения, а также от иных неправомерных действий третьих лиц.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          7.6.6. Оператор совместно с Пользователем принимает все необходимые меры по предотвращению убытков или иных
          отрицательных последствий, вызванных утратой или разглашением персональных данных.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          8. ОБЯЗАТЕЛЬНОЕ ХРАНЕНИЕ ДАННЫХ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          8.1. Права Пользователей, предусмотренные настоящей Политикой, могут быть ограничены в соответствии с
          требованиями действующего законодательства. В частности, такие ограничения могут предусматривать обязанность
          Оператора сохранить измененную или удаленную Пользователями информацию на срок, установленный
          законодательством, и/или передать такую информацию в соответствии с законодательно установленной процедурой
          государственному органу.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          9. СВЕДЕНИЯ ОБ ОБЕСПЕЧЕНИИ БЕЗОПАСНОСТИ ПЕРСОНАЛЬНЫХ ДАННЫХ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          9.1. Оператор назначает ответственного за организацию обработки персональных данных для выполнения
          обязанностей̆, предусмотренных ФЗ «О персональных данных» и принятыми в соответствии с ним нормативными
          правовыми актами.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          9.2. Оператор применяет комплекс правовых, организационных и технических мер по обеспечению безопасности
          персональных данных для обеспечения конфиденциальности персональных данных и их защиты от неправомерных
          действий:
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          9.2.1. Устанавливает правила доступа к персональным данным, обрабатываемым в информационной̆ системе Оператора,
          а также обеспечивает регистрацию и учёт всех действий с ними;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          9.2.2. Производит оценку вреда, который может быть причинен Пользователям в случае нарушения ФЗ «О
          персональных данных»;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          9.2.3. Производит определение угроз безопасности персональных данных при их обработке в информационной системе
          Оператора;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          9.2.4. Применяет организационные и технические меры и использует средства защиты информации, необходимые для
          достижения установленного уровня защищенности персональных данных;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          9.2.5. Осуществляет обнаружение фактов несанкционированного доступа к персональным данным и принимает меры по
          реагированию, включая восстановление персональных данных, модифицированных или уничтоженных вследствие
          несанкционированного доступа к ним;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          9.2.6. Производит оценку эффективности принимаемых мер по обеспечению безопасности персональных данных до
          ввода в эксплуатацию информационной системы Оператора;
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          9.2.7. Осуществляет внутренний контроль соответствия обработки персональных данных ФЗ «О персональных данных»,
          принятым в соответствии с ним нормативным правовым актам, требованиям к защите персональных данных, Политике,
          Положению и иным локальным актам, включающий контроль за принимаемыми мерами по обеспечению безопасности
          персональных данных и их уровня защищенности при обработке в информационной системе Оператора.
        </Typography>

        <Typography variant="h4" component="div" spacing={3}>
          10. СВЕДЕНИЯ ОБ ОПЕРАТОРЕ
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          10.1. База данных, содержащая персональные данные Пользователей – граждан Российской Федерации, находится на
          территории Российской Федерации.
        </Typography>

        <Typography variant="body3" component="div" spacing={3}>
          10.2. Для реализации своих прав и законных интересов Пользователи имеют право обратиться к Оператору, направив
          запрос лично или с помощью представителя по адресу, указанному в пункте 1.1. Политики либо на адрес
          электронной почты, указанный на Сайте. Запрос должен содержать сведения, указанные в ч. 3 ст. 14 ФЗ «О
          персональных данных».
        </Typography>
      </Container>
    </PageNext>
  );
};

export default PrivacyPolicyPage;
